import { FetchError } from 'api/API';
import { A02, A02Request } from 'api/U007';
import { useCallback, useState } from 'react';

export interface ConfirmResetPassword {
  status: string;
  msg: string;
}

type ConfirmResetPasswordDoRequest = (param: {
  request: A02Request;
  onSuccess?: (response: ConfirmResetPassword) => void;
  onError?: (err: Error) => void;
  cancellation?: AbortSignal;
}) => Promise<void>;

export function useConfirmResetPassword(): [ConfirmResetPasswordDoRequest, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const FetchConfirmResetPassword = async (param: A02Request, cancellation: AbortSignal) => {
    const json = await A02(param, cancellation);
    return json;
  };

  const doRequest: ConfirmResetPasswordDoRequest = useCallback(
    async ({ request, cancellation, onSuccess, onError }) => {
      const controller = new AbortController();
      const cancelSignal = cancellation ?? controller.signal;
      setLoading(true);
      setError(null);
      try {
        const result = await FetchConfirmResetPassword(request, cancelSignal);
        onSuccess?.(result);
      } catch (err) {
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.msg || `HTTP ERROR: ${err.message}`);
          onError?.(flooredError);
          setError(flooredError);
        } else {
          const flooredError = new Error(`unknown error. ${err}`);
          onError?.(flooredError);
          setError(flooredError);
        }
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return [doRequest, loading, error];
}
